export const BUSINESS_CATS = [
  { key: "hotels", pkg: "business" },
  { key: "restaurants", pkg: "business" },
  { key: "activities", pkg: "business" },
  { key: "ski", pkg: "business" },
  { key: "attractions", pkg: "business" },
  { key: "transport", pkg: "business" },
  { key: "cafes", pkg: "local" },
  { key: "saunas", pkg: "local" },
  { key: "shops", pkg: "local" },
];

export const EXTRA_ROLES = ["homeowner", "municipality", "sponsor", "other"];
export const SIGNUP_ROLES = [...BUSINESS_CATS.map((c) => c.key), ...EXTRA_ROLES];
export const PLACE_ROLES = [...BUSINESS_CATS.map((c) => c.key), "homeowner"];
export const ROLE_PACKAGE = { ...Object.fromEntries(BUSINESS_CATS.map((c) => [c.key, c.pkg])), municipality: "region", homeowner: "host" };
export const HOST_SIGNUP = "/supporter?package=host#signup";
export const AMENITIES = [
  "coffee", "tea", "snacks", "restaurant", "conversations", "phone_charging", "bike_charging", "car_charging",
  "shower", "room", "sauna", "bnb", "hotel", "camping", "parking", "toilet", "wifi",
];
